import { createReducer, on } from '@ngrx/store';
import {setDistrictId} from "../actions/rookie.actions";

export const rookieFeatureKey = 'rookie';

export interface RookieState {
  districtId: number|null
}

export const initialState: RookieState = {
  districtId: null
};

export const reducer = createReducer(
  initialState,
  on(setDistrictId, (state, action) => {
    return {
      ...state,
      districtId: action.districtId
    }

  })
);
